import React from 'react';
import BlogPartial from './blog';

const MslpPartial = ({ formik }) => {
  return <BlogPartial formik={formik} vehicleRequired={true} />;
};

export default MslpPartial;
